import { render, staticRenderFns } from "./PageFormPass.vue?vue&type=template&id=49fa3e9a&"
import script from "./PageFormPass.vue?vue&type=script&lang=js&"
export * from "./PageFormPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports